import React, { useState, useEffect, useCallback } from 'react';
import { styled } from 'styled-components';

const StyledLabel = styled.label`
    font-weight: bold;
    margin-bottom: 0.5rem;
`;

const Hint = styled.span`
  color: #888;
  font-size: 0.875rem;
  white-space: nowrap;

  @media screen and (max-width: 600px) {
    font-size: 0.7rem;
  }
`;

const InputField = ({ trailText, label, type, value, setValue }) => {
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    const cleanNumber = useCallback((value) => {
        const cleanedValue = value.replace(/\./g, '').replace(/\D/g, '');
        return cleanedValue ? parseInt(cleanedValue, 10) : null;
    }, []);

    const formatNumber = useCallback((value) => {
        if (value === null || value === '') return '';
        const number = parseInt(value, 10);
        return isNaN(number) ? '' : number.toLocaleString('tr-TR');
    }, []);

    const onInput = (event) => {
        const rawValue = event.target.value;
        const cleanedValue = cleanNumber(rawValue);
        setInternalValue(cleanedValue);
        setValue(cleanedValue);
    };

    const onKeyDown = (event) => {
        const allowedKeys = [46, 8, 9, 27, 13, 37, 38, 39, 40];
        if (allowedKeys.includes(event.keyCode) || 
            (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
            (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
            (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            return;
        }
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && event.keyCode !== 190) {
            event.preventDefault();
        }
    };

    return (
        <div className="py-2 input-group relative d-flex flex-column">
            <StyledLabel style={{ alignSelf: 'self-start' }}>{label}</StyledLabel>
            <div className="d-flex align-items-center">
                {type === 'number' ? (
                    <input
                        type="text"
                        placeholder={label}
                        className="form-control input-field-input border-0 mr-2 pr-2 shadow-sm component-bg"
                        value={formatNumber(internalValue)}
                        onInput={onInput}
                        onKeyDown={onKeyDown}
                    />
                ) : (
                    <input
                        type="text"
                        placeholder={label}
                        className="form-control input-field-input border-0 mr-2 pr-2 shadow-sm component-bg"
                        value={internalValue}
                        onInput={onInput}
                    />
                )}
                <Hint>{trailText}</Hint>
            </div>
        </div>
    );
};

export default InputField;
